import {Pagination} from '../pagination.model';
import {User} from '../../../../users/shared/model/user.model';

export class UserPage extends Pagination {
  content: User[] = [];
}
